import React from 'react';
import styles from './styles/userDataHeader.module.css';

import { FaChevronLeft } from 'react-icons/fa';

interface UserDataHeaderInterface {
  firstName?: string;
  lastName?: string;
  userStatus: string;
  userDataIndex: number;
  setUserDataIndex: any;
}

const UserDataHeader: React.FC<UserDataHeaderInterface> = ({
  firstName,
  lastName,
  userStatus,
  userDataIndex,
  setUserDataIndex,
}) => {
  function handleBack() {
    window.history.back();
  }

  function returnBadge() {
    switch (userStatus) {
      case 'ACTIVE':
        return {
          className: styles.badgeActive,
          text: 'Active',
        };
      case 'INACTIVE':
        return {
          className: styles.badgeInactive,
          text: 'Inactive',
        };

      case 'TERMINATED':
        return {
          className: styles.badgeTerminated,
          text: 'Terminated',
        };
      default: {
        return {
          className: styles.badgeActive,
          text: 'Active',
        };
      }
    }
  }

  const badge = returnBadge();
  console.log(badge);

  return (
    <div className={styles.wrapper}>
      <div className={styles.headerContainer}>
        <div onClick={handleBack} className={styles.leftContainer}>
          <FaChevronLeft />
          <p className={styles.backText}>Back</p>
        </div>
        <div className={styles.rightContainer}>
          <div className={styles.nameContainer}>
            <p className={styles.name}>{firstName}</p>
            <p className={styles.name}>{lastName}</p>
          </div>

          <div className={styles.secondLineName}>
            <p className={styles.employeeType}>Protector</p>
            <div className={returnBadge().className}>
              <p className={styles.badgeText}>{returnBadge().text}</p>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.pages}>
        {[
          'Protector Info',
          'Certifications',
          'Training Log',
          'Firearms',
          'Contracts & Agreements',
        ].map((item: string, index: number) => {
          if (index === userDataIndex) {
            return (
              <p
                onClick={() => setUserDataIndex(index)}
                className={styles.paginationItemUnderlined}
              >
                {item}
              </p>
            );
          } else {
            return (
              <p
                onClick={() => setUserDataIndex(index)}
                className={styles.paginationItem}
              >
                {item}
              </p>
            );
          }
        })}
      </div>
    </div>
  );
};

export default UserDataHeader;
